import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import urlParse from 'url-parse'
import { isEmpty, flatten, filter } from 'ramda'
import ConditionalRender from 'components/ConditionalRender'
import ScopeList from './ScopeList'
import defaultIconSrc from '../AppsPage/AppSection/defaultIcon.svg'
import { fetchAppScopeDescriptions } from 'api/developerApi'
import { fetchAppWithScopesByClient, authorizeApp } from 'api/customerApi'
import { showTransientNotification } from '@driftt/traffic-control'
import { Loader, Button } from '@driftt/tide-core'
import { defaultTo } from 'ramda'

import './style.css'

const DO_PARSE_QUERY = true
const parseUrl = (location) => urlParse(`${location.pathname}${location.search}`, DO_PARSE_QUERY)
const providedOrDefaultIcon = (iconUrl) => defaultTo(defaultIconSrc)(iconUrl);

const ERROR_MESSAGE = 'Oops, something went wrong. Please refresh the page.'

class AuthorizePage extends Component {

  state = {
    client_id: "",
    redirect_uri: "",
    state: "",
    isFetchingScopes: false,
    app: {},
    requestedScopes: [],
  }

  componentWillMount = (prevProps) => {
    const parsedUrl = parseUrl(this.props.location)
    this.setState({
      client_id: parsedUrl.query.client_id,
      redirect_uri: parsedUrl.query.redirect_uri,
      state: parsedUrl.query.state,
    })
  }

  componentDidMount = () => {
    this.fetchAppScopes(this.state.client_id)
  }

  fetchAppScopes = (client_id) => {
    const onDone = ([scopeDescriptionGroups, appWithScopes]) => {
      const flattenedScopeGroups = flatten(scopeDescriptionGroups.map((group) => group.scopes, scopeDescriptionGroups))
      this.setState({
        app: appWithScopes.developerIntegration,
        requestedScopes: filter((scopeDesc) => appWithScopes.scopes.includes(scopeDesc.name), flattenedScopeGroups),
      })
    }

    const onError = (error) => {
      this.props.showErrorNotification(ERROR_MESSAGE)
    }

    const onFinally = () => {
      this.setState({ isFetchingScopes: false })
    }

    const onStateSet = () => {
      Promise.all([
        fetchAppScopeDescriptions(),
        fetchAppWithScopesByClient(client_id),
      ])
        .then(onDone)
        .catch(onError)
        .then(onFinally)
    }

    this.setState({ isFetchingScopes: true }, onStateSet)
  }

  authorizeApp = () => {
    const { app, state, redirect_uri } = this.state

    const onDone = (result) => {
      if(!!result.redirectUrl) {
        window.location.replace(result.redirectUrl)
      } else {
        this.props.showErrorNotification(ERROR_MESSAGE)
      }
    }

    const onError = (error) => {
      this.props.showErrorNotification(ERROR_MESSAGE)
    }

    const onFinally = () => {
      this.setState({ isAuthorizing: false })
    }

    const onStateSet = () => {
      authorizeApp(app.id, state, redirect_uri)
        .then(onDone)
        .catch(onError)
        .then(onFinally)
    }

    this.setState({ isAuthorizing: true }, onStateSet)
  }

  handleCancel = () => {
    const { redirect_uri } = this.state
    if (!!redirect_uri) {
      window.location.replace(redirect_uri)
    } else {
      window.close()
    }
  }


  render() {
    const {
      isFetchingScopes,
      app,
      requestedScopes,
      isAuthorizing,
    } = this.state
    return (
      <div className="external-integration-wrapper">
        <ConditionalRender condition={!isEmpty(app)}>
          <div className="external-integration-content">
            <img
              className="apps-page-app-section-icon"
              src={providedOrDefaultIcon(app.iconUrl)}
              alt="app icon"
            />
            <h1 className="external-integration-install-modal-title"> Install { app.name } to Drift </h1>
            <span className="external-integration-install-modal-description"> { app.name } would like these permissions in Drift: </span>
            <ScopeList scopes={ requestedScopes } />
            <br/>
            <div className="external-integration-install-modal-buttons">
              <Button type="tertiary" size="medium"  onClick={this.handleCancel}>
                Cancel
              </Button>
              <Button type="primary" size="medium" loading={isAuthorizing} onClick={this.authorizeApp}>
                Authorize App
              </Button>
            </div>
          </div>
          </ConditionalRender>
          <ConditionalRender
            condition={ isFetchingScopes }>
            <Loader />
        </ConditionalRender>
      </div>
    )
  }
}

const mapStateToProps = null
const mapDispatchToProps = dispatch => ({
  showErrorNotification: (message) => dispatch(showTransientNotification({ type: 'error', message }))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthorizePage))
